import axios from "axios";
import { API_URL } from "./config";

const AXIOS = axios.create({
  baseURL: API_URL,
  headers: {
    isWeb: "true",
    "ngrok-skip-browser-warning": true,
  },
});

AXIOS.interceptors.response.use(
  (response) => response,
  (error) => {
    if (process.env.NODE_ENV !== "production") {
      console.log("GLOBAL_ERROR", error.response);
    }

    // if (error.response?.data?.status === 401) {
    //   localStorage.removeItem(`${AUTH_SAVE}`);
    //   window.location.reload();
    // }

    return Promise.reject(error);
  }
);

export default AXIOS;
